module.exports = __webpack_public_path__ + "img/trash-icon.50accd79.svg";